import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackToggledEmailDigestOn.meta';

export const useTrackToggledEmailDigestOn = () => {
  const { track } = useAnalyticsUtilities();

  const trackToggleEmailDigestOn = useCallback(() => {
    track(META.name);
  }, [track]);

  return {
    trackToggleEmailDigestOn,
  };
};
